/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copia'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nome',
    PROFIT_MARGIN: 'Percentuale commissione'
  },
  LABEL: {
    GENERATE_LINK: 'Genera link',
    GENERATED_LINK: 'Link generato',
    NAME: 'Nome',
    PROFIT_MARGIN: 'Percentuale commissione'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Link copiato'
  },
  TOOLTIP: {
    NAME: 'Nome',
    PROFIT_MARGIN: 'Percentuale commissione'
  }
};
